export default ".ng-logout-container{padding:20px}.ng-logout-container .jumbotron h3{color:#fff}.logout-message{padding-bottom:100px}";